import React, { useState } from 'react';
import { X, Mail, Phone, MapPin, Send } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import './Modal.css';

const ContactModal = ({ onClose }) => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t('contact.thanks'));
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2>{t('contact.title')}</h2>
        </div>

        <div className="modal-body contact-body">
          <div className="contact-info">
            <h3>{t('contact.info')}</h3>

            <div className="info-item">
              <Phone size={20} />
              <div>
                <strong>{t('contact.phone')}</strong>
                <p>+30 210 814 2770</p>
              </div>
            </div>

            <div className="info-item">
              <Mail size={20} />
              <div>
                <strong>Email</strong>
                <p>info@qals.gr</p>
              </div>
            </div>

            <div className="info-item">
              <MapPin size={20} />
              <div>
                <strong>{t('contact.address')}</strong>
                <p>Λεωφόρος Αθηνών 123</p>
                <p>Αθήνα, 15124</p>
              </div>
            </div>

            <div className="business-hours">
              <h4>{t('contact.hours')}</h4>
              <p>{t('contact.hoursWeek')}</p>
              <p>{t('contact.hoursSat')}</p>
              <p>{t('contact.hoursSun')}</p>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h3>{t('contact.sendMessage')}</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input type="text" name="name" placeholder={t('contact.namePh')}
                  value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <input type="email" name="email" placeholder="Email"
                  value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <input type="tel" name="phone" placeholder={t('contact.phonePh')}
                  value={formData.phone} onChange={handleChange} />
              </div>
              <div className="form-group">
                <textarea name="message" placeholder={t('contact.messagePh')} rows="6"
                  value={formData.message} onChange={handleChange} required />
              </div>
              <button type="submit" className="submit-button">
                <Send size={18} />
                {t('contact.send')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
